import React from 'react';
import { Link } from 'react-router-dom';
import BookAppointmentLink from '../components/BookAppointmentLink';
import Footer from '../components/Footer';

const Research: React.FC = () => {
  const resources = [
    {
      title: 'Dental care and general anesthesia',
      description: 'AAHA explains anesthesia considerations for veterinary dental procedures, including airway protection and planning for patients with additional health risks.',
      url: 'https://www.aaha.org/resources/2019-aaha-dental-care-guidelines-for-dogs-and-cats/general-anesthesia/',
      publisher: 'American Animal Hospital Association',
    },
    {
      title: 'Anesthesia assessment and monitoring',
      description: 'Guidance for veterinary teams on planning, monitoring, and recovery. Discuss which steps apply to your pet with the treating veterinarian.',
      url: 'https://www.aaha.org/globalassets/02-guidelines/2020-anesthesia/anesthesia_and_monitoring_guidelines_final.pdf',
      publisher: 'American Animal Hospital Association',
    },
    {
      title: 'Feline dental disease',
      description: 'An introduction to gingivitis, periodontitis, and tooth resorption in cats, with explanations of signs and treatment.',
      url: 'https://www.vet.cornell.edu/departments-centers-and-institutes/cornell-feline-health-center/health-information/feline-health-topics/feline-dental-disease',
      publisher: 'Cornell Feline Health Center',
    },
  ];

  return (
    <>
      <main className="bg-white py-16 sm:py-24">
        <div className="container-custom max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-6">Veterinary Dental Research and Guidance</h1>
          <p className="text-lg text-gray-600 mb-8">Use these veterinary resources to prepare questions about your pet’s dental care. An examination and individual treatment plan are needed to apply general guidance to your dog or cat.</p>
          <div className="space-y-6">
            {resources.map(resource => (
              <section key={resource.url} className="rounded-2xl border border-gray-200 p-6">
                <p className="text-sm text-gray-500 mb-2">{resource.publisher}</p>
                <h2 className="text-2xl font-semibold text-primary mb-3">{resource.title}</h2>
                <p className="text-gray-600 mb-4">{resource.description}</p>
                <a href={resource.url} className="text-brand-teal underline">Read the source</a>
              </section>
            ))}
          </div>
          <section className="mt-10">
            <h2 className="text-2xl font-semibold text-primary mb-4">Questions for your visit</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li>What did the examination find, and what further assessment is needed?</li>
              <li>What are the benefits and risks of the proposed treatment for my pet?</li>
              <li>What does the estimate include, and how will additional findings be discussed?</li>
              <li>What should I expect during recovery and follow-up?</li>
            </ul>
            <p className="mt-6"><Link to="/blog" className="text-brand-teal underline">Read Chomp’s dental guides</Link></p>
            <BookAppointmentLink analyticsSource="unknown" className="btn-primary inline-block mt-6">Request an Appointment</BookAppointmentLink>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Research;
